<template>
    <div>
        <h4 class="mb-3">
            <span class="text-muted">Riepilogo</span>
        </h4>
        <div class="bg-white border rounded small">

            <!-- Ateneo -->
            <div class="d-flex justify-content-between p-3 border-bottom">
                <span class="text-muted">Ateneo</span>
                <span class="fw-bold text-secondary ps-3 text-truncate" v-if="university">{{ university }}</span>
            </div>
            <!-- Categoria -->
            <div class="d-flex justify-content-between p-3 border-bottom">
                <span class="text-muted">Categoria</span>
                <span class="fw-bold text-secondary ps-3 text-truncate">{{ category }}</span>
            </div>
            <!-- Corso -->
            <div class="d-flex justify-content-between p-3 border-bottom" v-if="category != 'Esami Singoli'">
                <span class="text-muted">Corso</span>
                <span class="fw-bold text-secondary ps-3 text-truncate">{{ course }}</span>
            </div>
            <!-- ECP -->
            <div class="d-flex justify-content-between p-3 border-bottom">
                <span class="text-muted">{{ ecp_text }}</span>
                <div v-if="ecp">
                    <span class="fw-bold text-secondary ps-3 text-truncate">{{ ecp }}</span>
                </div>
            </div>
            <!-- Convenzione -->
            <div class="d-flex justify-content-between p-3 border-bottom" v-if="showConvention">
                <span class="text-muted">Agevolazione</span>
                <div v-if="convention">
                    <span class="fw-bold text-secondary ps-3 text-truncate">{{ convention }}</span>
                </div> 
            </div>
            <!-- Formula -->
            <div class="d-flex justify-content-between p-3 border-bottom" v-if="showProgram">
                <span class="text-muted">Formula</span>
                <span class="fw-bold text-uppercase text-secondary ps-3 text-truncate">{{ program }}</span>
            </div>
            <!-- Rate -->
            <div class="d-flex justify-content-between p-3 border-bottom" v-if="showInstallments">
                <span class="text-muted">Rate</span>
                <span class="fw-bold text-secondary">{{ rate }}</span>
            </div>
            <!-- Promo -->
            <div class="d-flex justify-content-between p-3 border-bottom" v-if="promo_code && aa == '2026/2027'">
                <span class="text-muted">Promo</span>
                <span class="fw-bold text-secondary">
                    <span v-if="convention == 'PUBBLICA AMMINISTRAZIONE'">PA</span>
                    <span v-else-if="convention == 'FORZE ARMATE E FORZE DELL\'ORDINE'">FORZE ARMATE</span>
                    <span v-else-if="promo_code == 'RIPARTI CON NOI'">RIPARTI CON NOI</span>
                    <span v-else>BACK TO UNI</span>
                </span>
            </div>
            <!-- Retta -->
            <div class="d-flex justify-content-between p-3 border-bottom" v-if="category != 'Esami Singoli'">
                <span class="text-muted">{{ category == 'Corso di Laurea' ? 'Retta 1° anno' : 'Retta' }}</span>
                <span class="fw-bold text-secondary" v-if="mp_tot && rate">€ {{ mp_tot }}</span>
            </div>
            <!-- Retta anni successivi -->
            <div class="d-flex justify-content-between p-3 border-bottom" v-if="installments_next && rate">
                <span class="text-muted">Retta anni successivi</span>
                <span class="fw-bold text-secondary">€ {{ installments_next.program.import }}</span>
            </div>
            
            <!-- Contributo Servizi agli Studenti -->
            <div class="d-flex justify-content-between p-3 border-bottom" v-if="rate && installments && installments[0].tax > 0 && category == 'Corso di Laurea'">
                <span class="text-muted">Contributo Servizi agli Studenti</span>
                <span class="fw-bold text-secondary">€ {{ installments[0].tax }}</span>
            </div>

            <!-- Multiversity Card -->
            <div class="d-flex justify-content-between p-3 border-bottom" v-if="rate && installments && installments[0].multiversity_card_price > 0 && category == 'Corso di Laurea'">
                <span class="text-muted">Multiversity Card</span>
                <span class="fw-bold text-secondary">€ {{ installments[0].multiversity_card_price }}</span>
            </div>

            <!-- Prospetto Rate Primo Anno -->
            <div class="p-3" v-if="rate && installments && category != 'Esami Singoli'">
                <p><strong>PROSPETTO RATE PRIMO ANNO</strong></p>
                <table class="table table-bordered table-sm text-secondary mb-0">
                    <thead>
                        <tr class="border-bottom">
                            <th class="bg-light">Scadenza</th>
                            <th class="bg-light text-center">Importo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(installment, index) in installments" :key="index" class="border-bottom"> 
                            <td width="70%">{{ installment.date }}</td> 
                            <td class="text-center">
                                <strong>€ {{ (Number(installment.import)).toFixed(2).replace('.', ',') }}</strong>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr class="border-bottom">
                            <th class="bg-light">Totale</th>
                            <th class="bg-light text-center">€ {{ (Number(mp_tot)).toFixed(2).replace('.', ',') }}</th>
                        </tr>
                    </tfoot>
                </table>
                <p class="mt-2 mb-0 small text-muted" v-if="installments[0].tax > 0">
                    <span v-if="category == 'Corso di Laurea'">
                        <span>{{ rate == 1 ? 'Al primo importo' : 'Ad ogni rata/importo' }}</span> si aggiungono <strong>€ {{ installments[0].tax / rate }}</strong> per il Contributo per i Servizi agli Studenti
                        <span v-if="installments && installments[0].multiversity_card_price > 0" class="d-block">
                            Alla prima rata si aggiungono <strong>€ {{ Number(installments[0].multiversity_card_price) }}</strong> per la Multiversity Card
                        </span>
                    </span>
                    <span v-else>
                        Al primo importo si aggiungono <strong>€ {{ installments[0].tax }}</strong> per spese di bollo
                    </span>
                </p>
                <p class="mt-2 mb-0 small text-muted" v-if="category == 'Corso di Laurea' && aa == '2025/2026'">
                    Per gli anni successivi all'anno di immatricolazione, la retta sarà incrementata forfettariamente di <strong>€ 60</strong> annui
                </p>
            </div>

            <!-- Prospetto Rate Eventuali Anni Successivi   -->
            <div class="px-3 pb-3" v-if="rate && installments_next && category != 'Esami Singoli'">
                <p><strong>PROSPETTO RATE EVENTUALI ANNI SUCCESSIVI</strong></p>
                <table class="table table-bordered table-sm text-secondary mb-0">
                    <thead>
                        <tr class="border-bottom">
                            <th width="70%" class="bg-light">Scadenza</th>
                            <th class="bg-light text-center">Importo</th>
                        </tr>
                    </thead>
                    <tbody v-if="installments_next.prospectus">
                        <tr v-for="(installment, index) in installments_next.prospectus" :key="index" class="border-bottom"> 
                            <td>{{ installment.date }}</td> 
                            <td class="text-center">
                                <strong>€ {{ (Number(installment.import)).toFixed(2).replace('.', ',') }}</strong>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td>Da versare ogni ultimo giorno del mese</td>
                            <td class="text-center"><strong>€ {{ (Number(installments_next.program.import) / 12).toFixed(2).replace('.', ',') }}</strong></td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr class="border-bottom">
                            <th class="bg-light">Totale</th>
                            <th class="bg-light text-center">€ {{ (Number(installments_next.program.import)).toFixed(2).replace('.', ',') }}</th>
                        </tr>
                    </tfoot>
                </table>
                <p class="mt-2 mb-0 small text-muted" v-if="installments_next.program.tax > 0">
                    <span v-if="category == 'Corso di Laurea'">
                        <span>
                            Ad ogni rata/importo si aggiungono <strong>€ {{ installments_next.program.tax / rate }}</strong> 
                            per il Contributo per i Servizi agli Studenti
                        </span>
                        <span v-if="installments && installments[0].multiversity_card_price > 0" class="d-block">
                            Alla prima rata si aggiungono <strong>€ {{ Number(installments[0].multiversity_card_price) }}</strong> per la Multiversity Card
                        </span>
                    </span>
                    <span v-else>
                        Al primo importo si aggiungono <strong>€</strong> per 
                        spese di bollo
                    </span>
                    <span v-if="aa == '2025/2026'" class="d-block">
                        La retta sarà incrementata forfettariamente di <strong>€ 60</strong> annui
                    </span>
                </p>
            </div>

            <div class="px-3 py-3" v-if="singles">
                <p><strong>PROSPETTO</strong></p>
                <table class="table table-bordered table-sm text-secondary m-0">
                    <thead>
                        <tr class="border-bottom">
                            <th class="bg-light text-center">CFU</th>
                            <th class="bg-light text-center">Costo/CFU</th>
                            <th class="bg-light text-center">Importo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="border-bottom"> 
                            <td class="text-center">{{ singles.sumCfu }}</td> 
                            <td class="text-center">€ {{ singles.importCfu }}</td> 
                            <td class="text-center"><strong>€ {{ singles.import }}</strong></td>
                        </tr>
                    </tbody>
                </table>
                <p class="mt-2 mb-0 small text-muted">
                    Si aggiungono <strong>€ 120</strong> 
                    per il Contributo per i Servizi agli Studenti
                </p>
            </div>

        </div>
    </div> 
</template>

<script>
    export default {
        computed: {
            university() {
                return this.$store.getters['settings/from'].name
            },
            categorySettings() {
                return this.$store.getters['settings/category']
            },
            category() {
                return this.$store.getters['summary/category']
            },
            course() {
                return this.$store.getters['summary/course']
            },
            ecp() {
                return this.$store.getters['summary/ecp']
            },
            ecp_text() {
                return this.$store.getters['settings/from'].ecp_text
            },
            convention() {
                return this.$store.getters['summary/convention']
            },
            program() {
                return this.$store.getters['summary/program']
            },
            rate() {
                return this.$store.getters['summary/rate']
            },
            mp_tot() {
                return this.$store.getters['summary/mp_tot']
            },
            installments() {
                return this.$store.getters['summary/installments']
            },
            installments_next() {
                return this.$store.getters['summary/installments_next']
            },
            singles() {
                return this.$store.getters['summary/singles']
            },
            showConvention() {
                return this.category != '24 CFU'
            },
            showProgram() {
                return this.category != 'Esami Singoli' && this.category != '24 CFU'
            },
            showInstallments() {
                return this.category != 'Esami Singoli' && this.category != '24 CFU'
            },
            aa () {
                return this.$store.getters['summary/aa']
            },
            promo_code () {
                return this.$store.getters['summary/promo_code']
            }
        }
    }
</script>

<style>

</style>